<template>
  <div class="groupingManagement-page">
    <div class="all-content-container">
      <div class="table-container">
        <div class="table-title-container">
          <el-button type="primary" @click="handleAdd"
            >添加</el-button
          >
        </div>
        <div class="table-content-container">
          <el-table
            :data="tableData"
            align="center"
            class="data-table"
            v-loading="loading"
            style="width: 100%"
            :header-cell-style="{ background: '#F4F5F7' }"
          >
            <el-table-column align="center" label="类型图片">
              <template slot-scope="scope">
                <el-image
                  style="height: 50px"
                  :src="scope.row.image"
                  :preview-src-list="[scope.row.image]"
                  fit="contain"
                >
                </el-image>
              </template>
            </el-table-column>
            <el-table-column align="center" label="类型名称">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>
            <el-table-column align="center" label="排序号">
              <template slot-scope="scope">
                <p>{{ scope.row.orderNum }}</p>
              </template>
            </el-table-column>
            <el-table-column fixed="right" align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="handleEdit(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleDel(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-dialog
            :title="addEditTitle"
            :visible.sync="addEditIsDialog"
            :before-close="handleCancel"
            width="600px"
            center
            style="z-index: 10000"
          >
            <el-form
              ref="ruleForm"
              :rules="rules"
              :model="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-row>
                <el-col :span="24">
                  <el-form-item label="分组类型：" prop="image">
                    <UploadImg
                      para="image"
                      @setImg="setImg"
                      :imgUrl="ruleForm.image"
                      width="150"
                      height="100"
                    ></UploadImg>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="类型名称：" prop="name">
                    <el-input
                      v-model="ruleForm.name"
                      placeholder="请输入类型名称"
                      maxlength="20"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="排序号：" prop="orderNum">
                    <el-input-number
                      placeholder="请输入排序号"
                      v-model="ruleForm.orderNum"
                      :precision="0"
                      :step="1"
                      :min="0"
                      :max="9999"
                      size="small"
                      clearable
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="handleCancel">取 消</el-button>
              <el-button type="primary" @click="handleSave">确 定</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import UploadImg from "@/components/upload/UploadImg.vue";

export default {
  components: { UploadImg },
  data() {
    return {
      searchForm: {
        // 查询字段
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      ruleForm: {
        // 表单字段
        image: "",
        name: "",
        orderNum: "",
      },
      rules: {
        image: [{ required: true, message: "请选择类型图片", trigger: "blur" }],
        name: [
          { required: true, message: "请输入类型名称", trigger: "change" },
        ],
        orderNum: [
          { required: true, message: "请输入排序号", trigger: "blur" },
        ],
      },
      addEditId: "",
      addEditIsDialog: false,
      addEditTitle: "",
    };
  },
  created() {
    // 获取列表
    this.getList();
  },
  // 函数集合
  methods: {
    // 查询
    handleSearch() {
      this.searchForm.pageNum = 1;
      this.getList();
    },
    // 重置
    handleRest() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
      };
      this.getList();
    },
    // 分页查询
    handleCurrentChange: function (currentPage) {
      this.searchForm.pageNum = currentPage;
      this.getList();
    },
    // 分页获取列表
    getList() {
      this.loading = true;
      this.$api.system.getConfigGroupTypeList(this.searchForm).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.tableData = res.data;
          this.total = res.count;
        }
      });
    },
    // 删除
    handleDel(row) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.system.delConfigGroupType(row.id).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 编辑
    handleEdit(row) {
      this.addEditIsDialog = true;
      this.addEditTitle = "编辑分组类型";
      this.ruleForm.id = row.id;

      // 获取详情
      this.$api.system.getConfigGroupType({ id: row.id }).then((res) => {
        if (res.code == 200) {
          this.ruleForm = res.data;
        }
      });
    },
    // 添加
    handleAdd() {
      this.addEditIsDialog = true;
      this.addEditTitle = "添加分组类型";
      this.ruleForm.id = "";
    },
    // 取消
    handleCancel() {
      this.$refs["ruleForm"].resetFields();
      this.addEditIsDialog = false;
    },
    // 保存
    handleSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$api.system.saveConfigGroupType(this.ruleForm).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.handleCancel();
              this.handleSearch();
            }
          });
        }
      });
    },
    // 上传图片
    setImg(url) {
      this.ruleForm.image = url;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/groupingManagement.scss";

.demo-ruleForm {
  width: 95%;
  margin: 0 auto;
  padding-top: 10px;

  .el-select {
    width: 100% !important;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-cascader {
    width: 100% !important;
    margin-bottom: 0px !important;
  }
}
</style>